import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import './iot.scss';
import Config from '../../../Config';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import SwiperCore, {EffectFade, Navigation} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import Lottie from 'react-lottie';
import axios from 'axios';

SwiperCore.use([Navigation, EffectFade]);
const MainIot = (props) => {
  const title = !isMobile ? props?.iContent?.mainTitleDestop?.value : props?.iContent?.mainTitleMobile?.value;
  const bottomSpace = props?.iContent?.bottomSpace?.value;
  const items = props?.iContent?.itemsDesktop?.expandedValue;
  const linkBtnText = !isMobile ? props?.iContent?.linkBtnTextDesktop?.value : props?.iContent?.linkBtnTextMobile?.value;
  const linkUrl = !isMobile ? props?.iContent?.linkDesktop?.value : props?.iContent?.linkMobile?.value;
  const [itemIndex, setItemIndex] = useState(0);
  const [swiperInstence, setSwiperInstence] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [jsonData, setJsonData] = useState('');

  let defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: jsonData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    const url = isMobile
      ? Config.epiBaseUrl + items[itemIndex]?.animationMobile?.value?.url
      : Config.epiBaseUrl + items[itemIndex]?.animationDesktop?.value?.url;
    console.log(items[itemIndex]);
    axios({
      url: url,
      responseType: 'json',
      credentials: 'include',
      mode: 'no-cors',
      headers: {
        Accept: 'application/json; odata=verbose',
      },
    }).then((response) => {
      setJsonData(response.data);
    });
  }, [itemIndex]);

  const selectIndex = (index) => {
    setItemIndex(index);
  };

  const navigateToUrl = (url) => {
    props.context.navigateTo(url);
  };

  return (
    <div className='main-iot-block'>
      <div className='container'>
        <div className='title'>{title}</div>
        {isMobile && (
          <div className='swiper-mobile-slider'>
            <Swiper
              navigation={false}
              slidesPerView={3}
              spaceBetween={10}
              onSwiper={(swiper) => {
                setSwiperInstence(swiper);
              }}
              effect='slide'
              onSlideChange={(swiper) => {
                setActiveIndex(swiper?.activeIndex);
              }}>
              {items != null &&
                items?.map((val, i) => (
                  <>
                    <SwiperSlide key={i} className='slides-box'>
                      <div className={`${i == itemIndex ? 'is-selected' : ''} item-style`} onClick={() => selectIndex(i)}>
                        <div>{val?.itemTitleMobile?.value}</div>
                        {console.log('index :' + i + ' title :' + val?.itemTitleMobile?.value)}
                      </div>
                    </SwiperSlide>
                  </>
                ))}
            </Swiper>
          </div>
        )}
        {isMobile && (
          <div className='item-info'>
            <div className='item-info-title'>
              <div className='img-location'>
                <Image src={Config.epiBaseUrl + items[itemIndex]?.iconMobile?.expandedValue?.url} />
              </div>
              <div className='item-title'>{items[itemIndex].itemTitleDestop?.value}</div>
            </div>
            <div>
              <div className='main-img' style={{padding: '15px'}}>
                {jsonData != '' ? (
                  <Lottie options={defaultOptions}>
                    <Image style={{width: '95%', marginRight: '10px'}}
                      src={Config.epiBaseUrl + items[itemIndex]?.imageMobile?.expandedValue?.url} />
                  </Lottie>
                ) : (
                  <Image style={{width: '95%', marginRight: '10px'}}
                    src={Config.epiBaseUrl + items[itemIndex]?.imageMobile?.expandedValue?.url} />
                )}
              </div>
              <div className='mobile-info'>{items[itemIndex]?.mobileInfo?.value}</div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className='frame'>
            <div className='frame-list'>
              {items != null &&
                items?.map((val, i) => (
                  <>
                    <div className={`${i == itemIndex ? 'is-selected' : ''} item-style`} onClick={() => selectIndex(i)}>
                      <div className='img-location'>
                        <Image src={
                            !isMobile
                              ? Config.epiBaseUrl + val?.iconDesktop?.expandedValue?.url
                              : Config.epiBaseUrl + val?.iconeMobile?.expandedValue?.url
                          } />
                      </div>
                      <div className='item-title'>{!isMobile ? val?.itemTitleDestop?.value : val?.itemTitleMobile?.value}</div>
                    </div>
                  </>
                ))}
            </div>

            <div className='spaces'>
              {items != null &&
                items?.map((val, i) => (
                  <>
                    <div className={`${i == itemIndex ? 'is-selected' : ''} space-item`}></div>
                  </>
                ))}
            </div>
            <div className='frame-img'>
              <div className={`${itemIndex == 0 ? 'first-active' : ''} frame-img-size ${itemIndex == 6 ? 'last-active' : ''}`}>
                {defaultOptions.animationData != '' && (
                  <Lottie options={defaultOptions}>
                    <Image src={
                        !isMobile
                          ? Config.epiBaseUrl + items[itemIndex]?.imageDesktop?.expandedValue?.url
                          : Config.epiBaseUrl + items[itemIndex]?.imageMobile?.expandedValue?.url
                      } />
                  </Lottie>
                )}
              </div>
              <div className={`${itemIndex == items?.length - 1 ? 'last' : ''} bottom-txt`}>
                <div className='txt-style'>{items[itemIndex]?.info?.value}</div>
              </div>
            </div>
          </div>
        )}
        <div className='bottom-area'>
          {items?.length < 7 && <div style={{marginTop: '30px'}}></div>}

          <div className='btn'>
            <BtnWhite
              text={linkBtnText}
              onclick={() => {
                window.scrollTo(0, 0);
                navigateToUrl(linkUrl);
              }}
            />
          </div>
          {bottomSpace == true && <div className='bottom-space'></div>}
        </div>
      </div>
    </div>
  );
};

export default MainIot;
